import request from "@/utils/request"

/**
 * 获取下载链接列表
 * @param {Object} params - 查询参数
 */
export function getDownloadUrlList(params) {
    return request({
        url: '/api/article/download/list',
        method: 'get',
        params: params
    })
}

/**
 * 获取文章列表
 * @param {Object} params - 查询参数
 */
export function listArticle(params) {
    return request({
        url: '/api/elasticsearch/article/list',
        method: 'get',
        params: params
    })
}

/**
 * 获取文章详情
 * @param {Object} params - 查询参数
 */
export function getArticleDetail(params) {
    return request({
        url: '/api/article/detail',
        method: 'get',
        params: params
    })
}

/**
 * 统计文章下载次数
 * @param {Object} params - 查询参数
 */
export function countDownload(params) {
    return request({
        url: '/api/article/count/download',
        method: 'get',
        params: params
    })
}
